<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path :fill="color || 'white'" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
    </svg>
</template>
<script>
export default {
    name: "check",
    props: ["color"],
};
</script>


// WEBPACK FOOTER //
// src/components/V2/svg/components/Check.vue